import {modelDescriptions} from '@cdo/apps/aichat/constants';
import Lab2Registry from '@cdo/apps/lab2/Lab2Registry';
import {ValueOf} from '@cdo/apps/types/utils';
import {AiChatModelIds} from '@cdo/generated-scripts/sharedConstants';

type ModelId = ValueOf<typeof AiChatModelIds>;

const SUPPORTED_MODEL_IDS = modelDescriptions.map(model => model.id);

/**
 * Ensures that the given model ID is supported and allowed on this level (if applicable).
 * If not, returns the first supported model ID.
 * @param modelId model ID to check
 * @param allowedModelIds list of model IDs allowed on this level
 * @param supportedModelIds for testing only; override list of model IDs our system supports
 */
export const validateModelId = (
  modelId: ModelId,
  allowedModelIds: ModelId[] = [],
  supportedModelIds = SUPPORTED_MODEL_IDS // For testing
) => {
  if (
    supportedModelIds.includes(modelId) &&
    (allowedModelIds.length === 0 || allowedModelIds.includes(modelId))
  ) {
    return {isValid: true, modelId};
  }

  const supportedAndAllowed =
    allowedModelIds.length > 0
      ? supportedModelIds.filter(id => allowedModelIds.includes(id))
      : supportedModelIds;

  if (supportedAndAllowed.length === 0) {
    Lab2Registry.getInstance()
      .getMetricsReporter()
      .logWarning(
        'No overlap between levelbuilder-allowed models and supported models. Defaulting to first supported model.'
      );
    return {isValid: false, modelId: supportedModelIds[0]};
  }

  return {isValid: false, modelId: supportedAndAllowed[0]};
};
